import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="nubia-gradient text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6 hover:opacity-90 transition-opacity">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-nubia-gold-primary rounded-lg flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-nubia-green-primary">
                    <circle cx="12" cy="12" r="5"/>
                    <line x1="12" y1="1" x2="12" y2="3"/>
                    <line x1="12" y1="21" x2="12" y2="23"/>
                    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
                    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                    <line x1="1" y1="12" x2="3" y2="12"/>
                    <line x1="21" y1="12" x2="23" y2="12"/>
                    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
                    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
                  </svg>
                </div>
                <div>
                  <div className="text-2xl font-bold text-white" style={{ fontFamily: 'Lora, serif' }}>Nubia Solar</div>
                </div>
              </div>
            </Link>
            <p className="text-nubia-white/80 text-sm leading-relaxed mb-6">
              Instalación de sistemas de energía solar en España para hogares y empresas que quieren ahorrar y ganar independencia energética.
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-sm">
                <div className="w-8 h-8 rounded-full bg-nubia-gold-primary/20 flex items-center justify-center flex-shrink-0">
                  <Phone className="w-4 h-4 text-nubia-gold-primary" />
                </div>
                <a href="tel:+34604921745" className="hover:text-nubia-gold-soft transition-colors">+34 604 92 17 45</a>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <div className="w-8 h-8 rounded-full bg-nubia-gold-primary/20 flex items-center justify-center flex-shrink-0">
                  <Mail className="w-4 h-4 text-nubia-gold-primary" />
                </div>
                <a href="mailto:info@nubiasolar.com" className="hover:text-nubia-gold-soft transition-colors">info@nubiasolar.com</a>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <div className="w-8 h-8 rounded-full bg-nubia-gold-primary/20 flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-4 h-4 text-nubia-gold-primary" />
                </div>
                <span>Madrid, Valencia y Extremadura</span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-nubia-gold-primary font-semibold text-lg mb-6">Navegación</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm hover:text-nubia-gold-soft transition-colors inline-block">Inicio</Link></li>
              <li><Link to="/empresa" className="text-sm hover:text-nubia-gold-soft transition-colors inline-block">Empresa</Link></li>
              <li><Link to="/servicios" className="text-sm hover:text-nubia-gold-soft transition-colors inline-block">Servicios</Link></li>
              <li><Link to="/instalaciones" className="text-sm hover:text-nubia-gold-soft transition-colors inline-block">Instalaciones</Link></li>
              <li><Link to="/beneficios" className="text-sm hover:text-nubia-gold-soft transition-colors inline-block">Beneficios</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-nubia-gold-primary font-semibold text-lg mb-6">Servicios</h3>
            <ul className="space-y-3">
              <li className="text-sm text-nubia-white/80">Instalación de paneles solares</li>
              <li className="text-sm text-nubia-white/80">Asesoramiento energético</li>
              <li className="text-sm text-nubia-white/80">Optimización del consumo</li>
              <li className="text-sm text-nubia-white/80">Soluciones residenciales</li>
              <li className="text-sm text-nubia-white/80">Soluciones empresariales</li>
              <li className="text-sm text-nubia-white/80">Mantenimiento y soporte</li>
            </ul>
          </div>

          <div>
            <h3 className="text-nubia-gold-primary font-semibold text-lg mb-6">Horario</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-nubia-gold-primary mt-0.5 flex-shrink-0" />
                <div className="text-sm">
                  <div className="font-medium mb-2">Atención al cliente</div>
                  <div className="text-nubia-white/80 space-y-1">
                    <div>Lunes - Viernes</div>
                    <div>9:00 - 18:00</div>
                    <div className="mt-2">Sábados</div>
                    <div>10:00 - 14:00</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-nubia-gold-primary/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-nubia-white/70">© {currentYear} Nubia Solar. Todos los derechos reservados.</p>
            <div className="flex gap-6 text-sm flex-wrap justify-center">
              <Link to="/politica-privacidad" className="text-nubia-white/70 hover:text-nubia-gold-soft transition-colors">Política de Privacidad</Link>
              <Link to="/aviso-legal" className="text-nubia-white/70 hover:text-nubia-gold-soft transition-colors">Aviso Legal</Link>
              <Link to="/cookies" className="text-nubia-white/70 hover:text-nubia-gold-soft transition-colors">Cookies</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
